module.exports = __webpack_public_path__ + "static/hasura-a3504be6c111d73435674d609cb84fbf.png";